const actionTypeIdentifier = 'B263A466-292C-4826-9010-2D0FB72F29EC';

export const getAddCostAllocation = `GET-ADD-COST-ALLOCATION-${actionTypeIdentifier}`;
export const addCostAllocationDetails = `ADD-COST-ALLOCATION-DETAILS${actionTypeIdentifier}`;
export const updateCircuitCostAllocationItem = `UPDATE-CIRCUIT-COST-ALLOCATION-ITEM${actionTypeIdentifier}`;
export const deleteCostAllocationDetails = `DELETE-COST-ALLOCATION-DETAILS${actionTypeIdentifier}`;

export const circuitCostAllocationFormModel = {
    Key: 0,
    CostAllocationID: -1,
    GLCodeID: null,
    GLCode: null,
    GLCodeName: null,
    CostCodeID: null,
    CostCode: null,
    CompanyCode: null,
    CostCodePercent: null,
    LastModified: null,
}